﻿import { Utilities } from "./Utilities";
import { ApiClient } from "../ApiClient";

export default class AuthenticationManager {

    storageKey: string = 'LS.UserDetails';
    apiBaseUri: string = '/api/2012-02-01/pub/resources/newportal';
    webBaseUrl: string;
    portalEnabled: boolean;
    loginForRegistrationEnabled: boolean;
    IsLoggedIn: boolean = false;
    apiClient: IApiClient;

    constructor(portalEnabled: boolean, loginForRegistrationEnabled: boolean, webBaseUrl: string, apiClient: IApiClient) {
        this.webBaseUrl = webBaseUrl;
        this.portalEnabled = portalEnabled;
        this.loginForRegistrationEnabled = loginForRegistrationEnabled;
        this.apiClient = apiClient;

        if (loginForRegistrationEnabled === null || loginForRegistrationEnabled === undefined) {
            // Default to checking authentication in case the parameter has not been set properly
            this.loginForRegistrationEnabled = true;
        }

        var me = this;
        window.addEventListener('userAuthChange', () => { this.userAuthChange(me); });

        this.init();
    }

    async init() {
        this.IsAuthenticated();

        return jQuery.Deferred(); //not necessary except for current TS build configuration
    }

    userAuthChange(me: AuthenticationManager) {
        var currentUser = me.getCurrentUser();
        var $portalLoginName = jQuery('.portal-login-name');
        var $portalLoginMenu = jQuery('.portal-login-menu');
        var $portalMenuButton = jQuery("#portal-menu-button");
        var $portalMenu = jQuery("#portal-menu");
        var $portalLogin = jQuery('.portal-login');

        me.IsLoggedIn = me.loginForRegistrationEnabled && currentUser != null && !currentUser.IsGuest;

        if (me.portalEnabled && me.IsLoggedIn) {
            $portalLoginName.text(currentUser.FirstName + ' ' + currentUser.LastName);
            $portalLogin.addClass('authenticated');
            $portalLoginMenu.addClass('portalEnabled');
            $portalMenuButton.addClass('portalEnabled');
            $portalMenu.addClass('portalEnabled');
        } else if(me.portalEnabled) {
            $portalLoginName.text('Login');
            $portalLogin.removeClass('authenticated');
            $portalLoginMenu.removeClass('portalEnabled');
            $portalMenuButton.removeClass('portalEnabled');
            $portalMenu.removeClass('portalEnabled');
        }
    }

    private getCurrentUser(): any {

        var user = sessionStorage[this.storageKey];
        if (!user) {
            return null;
        }
        return JSON.parse(user);
    }

    async IsAuthenticated() {
        var me = this;

        if (!this.loginForRegistrationEnabled) {
            window.dispatchEvent(new Event('userAuthChange'));
            return;
        }

        return this.apiClient.getData(this.apiBaseUri + '/authenticate', {
            success: function (user: any) {
                window.sessionStorage.setItem(me.storageKey, (<any>window).JSON.stringify(user));
            },
            error: function (error: any) {
                window.sessionStorage.removeItem(me.storageKey);
            },
            complete: function () {
                window.dispatchEvent(new Event('userAuthChange'));
            },
            scope: me
        });
    }
}
